// @flow
import env from '../../../environment';
import {putCreator, getCreator} from '../../../http';

export const endpoints = Object.freeze({
  SAVE_ACCOUNT: `${env.baseApiUrl}/usher/user/vendor/data`,
  CHANGE_PASSWORD: `${env.baseApiUrl}/usher/user/vendor/password`,
  FETCH_SUBSCRIPTION_SETTING: `${env.baseApiUrl}/checkout/admin/subscription/setting`,
  SAVE_SUBSCRIPTION_SETTING: `${env.baseApiUrl}/checkout/admin/subscription/setting`,
});

export type SaveAccountRequest = {
  email?: string,
  firstName?: string,
  lastName?: string,
  password?: string,
  phone?: string,
};

export const saveAccountApi = putCreator(endpoints.SAVE_ACCOUNT);
export const fetchSubscriptionSettingApi = getCreator(
  endpoints.FETCH_SUBSCRIPTION_SETTING
);
export const saveSubscriptionSettingApi = putCreator(
  endpoints.SAVE_SUBSCRIPTION_SETTING
);

export const changePasswordApi = putCreator(endpoints.CHANGE_PASSWORD);
